import React from "react";
import logo from '../logo-asset/tasty-drk.png'
const About = () => {
  return (
    <div className="home-cnt">
      <div className="about-cnt">
        <h2 style={{color:'#fff'}} className="about-title">So.. What is <span style={{fontWeight:'900'}}>TASTY</span> ??</h2>
        <br />
        <p>
        How many times have you called your mom/grandma or some other crazy good chef in your family to ask for that recipe that you love? I bet more than once! <br />
        Introducing <span style={{fontWeight:'600', color:'dodgerblue'}}>TASTY The Recipes Database</span>, a digital cookbook I built with a heartfelt purpose. <br /> <br /> I am Nico, I am a native Italian living in the USA, I lost count of how many times I called my mom in Italy to ask for a recipe, and most times I would just have that recipe saved as a message, a vocal message or some random piece of paper that would inevitably get lost at some point, I really thought to myself "traditional recipes remid us of our childhood and just like memories they should be preserved" Inspired by this, I created TASTY a sharable digital cookbook where you can find recipes and save new ones. This web app serves as a platform for food enthusiasts to come together, sharing their cherished family recipes while exploring new culinary adventures.
        <br /><br /> Join me in bringing loved ones closer through the universal language of food with TASTY The Recipes Database. I'm Nico, and I invite you to savor every moment of this culinary experience. <br />
        Also check out my <a href="https://nikogermano.com/">portfolio</a> to demo other things I built.
        </p>
        <br />
        <img src={logo} alt="" />
      </div>
    </div>
  );
};

export default About;
